import { render, staticRenderFns } from "./DressOldCard.vue?vue&type=template&id=6cfa9001&scoped=true"
import script from "./DressOldCard.vue?vue&type=script&lang=js"
export * from "./DressOldCard.vue?vue&type=script&lang=js"
import style0 from "./DressOldCard.vue?vue&type=style&index=0&id=6cfa9001&prod&lang=scss&scoped=true"
import style1 from "./DressOldCard.vue?vue&type=style&index=1&id=6cfa9001&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa9001",
  null
  
)

export default component.exports